import React from 'react';
import { Stack, SizableText, useTheme } from 'tamagui';
import { Flex } from 'components/base/General';
import { IListCard } from 'interfaces/component/ListCard';

const ListCard = (props: IListCard) => {
  const theme = useTheme();
  return (
    <Flex
      {...props.wholeCard}
      bg={props.color ? props.color : theme.listCardBodyGray}
      borderColor={theme.mutedBorder.get()}
      style={{
        borderTopWidth: 2,
        borderBottomWidth: 2,
        paddingLeft: 10,
        paddingBottom: 10,
        paddingRight: 10,
        paddingTop: 5,
        flex: 1,
      }}
    >
      <Stack {...props.top}>
        <Stack {...props.topLeft}>{props.topLeftItem}</Stack>
        <Stack {...props.topCenter}>
          <SizableText {...props.topCenterText}>
            {props.topCenterItem}
          </SizableText>
        </Stack>
        <Stack {...props.topRight}>
          <SizableText {...props.topRightText}>
            {props.topRightItem}
          </SizableText>
        </Stack>
      </Stack>
      <Stack {...props.center}>
        <Stack {...props.centerLeft}>{props.centerLeftItem}</Stack>
        <Stack {...props.centerCenter}>
          <SizableText {...props.centerCenterText}>
            {props.centerCenterItem}
          </SizableText>
        </Stack>

        <Stack {...props.centerRight}>
          <SizableText {...props.centerRightText}>
            {props.centerRightItem}
          </SizableText>
        </Stack>
      </Stack>

      <Stack {...props.bottom}>
        <Stack {...props.bottomLeft}>
          <SizableText {...props.bottomLeftText}>
            {props.bottomLeftItem}
          </SizableText>
        </Stack>

        <Stack {...props.bottomCenter}>
          <SizableText {...props.bottomCenterText}>
            {props.bottomCenterItem}
          </SizableText>
        </Stack>

        <Stack {...props.bottomRight}>
          <SizableText {...props.bottomRightText}>
            {props.bottomRightItem}
          </SizableText>
        </Stack>
      </Stack>
    </Flex>
  );
};

export default ListCard;
